/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Alchemy, Table, TableCell, TableColumnHeaderCell, TableRow, TableRowExpand } from '@blend/alchemy';
import { BrandColors } from '@blend/enterprise-components';
import { Box, Button as GButton } from 'grommet';
import styled from 'styled-components';
import { maxTableWidth } from 'blb-styles/constants';
export const ModalStyles = {
  content: {
    height: '250px',
    width: '544px'
  }
};
export const StyledAlchemy = styled(Alchemy)`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;
export const FormColumnWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;
`;
export const RemoveButtonWrapper = styled.div`
  &:nth-of-type(0) {
    margin-top: 4px;
  }

  align-items: center;
`;
export const AlertButton = styled(GButton)`
  color: white;

  &:hover {
    background-color: ${props => props.hoverColor};
  }
`;
export const AddMemberButtonWrapper = styled.div`
  margin-top: 12px;
`;
export const MemberFields = styled.ul`
  margin-top: 12px;
`;
export const FullWidthTable = styled(Table)`
  width: 100%;
  margin: 1rem 0;
`;
export const NestedTable = styled(Table)`
  max-width: calc(${maxTableWidth}px - 4rem);
  margin: 1rem 0;
  border-radius: 4px;
  overflow: hidden;
`;
export const StyledRow = styled(TableRow)`
  & > * {
    border: none; /* we shouldn't have to do that but there is a bug in Alchemy's table styles */
    padding-bottom: 0.5rem;
  }
  & > :first-child {
    padding-left: 1.5rem;
  }
`;
export const StyledExpandableRow = styled(StyledRow)`
  border-bottom: solid 1px ${BrandColors.CLOUD_30};
`;
export const NestedHeaderRow = styled(StyledRow)`
  & > * {
    background: ${BrandColors.CLOUD_10};
    padding-bottom: 0.75rem;
  }
`;
export const StyledRowExpand = styled(TableRowExpand)`
  background: ${BrandColors.CLOUD_30};
  padding: 0 1.5rem 0 2.5rem;
`;
export const EllipsisCell = styled(TableCell).attrs(props => ({
  title: props.children?.toString()
}))`
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const TableColumnHeaderNoWrapCell = styled(TableColumnHeaderCell)`
  white-space: nowrap;
`;
export const TableColumnHeaderFlushedRightCell = styled(TableColumnHeaderCell)`
  text-align: right;
`;
export const ActionsCell = styled(TableCell)`
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  /* Tweak padding to keep row height and baseline consistent. */
  padding-top: 7px;
  padding-bottom: 8px;
`;